"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PricingTable_1 = require("../PricingTable");
class PricingMerchandiseOption {
    constructor({ id, name, displayToOptimizer, helpUrlForDirector, helpUrlForOptimizer, pricingTables, }) {
        this.toJSON = () => ({
            id: this.id,
            name: this.name,
            displayToOptimizer: this.displayToOptimizer,
            helpUrlForDirector: this.helpUrlForDirector,
            helpUrlForOptimizer: this.helpUrlForOptimizer,
            pricingTables: this.pricingTables,
        });
        // creative formatを元にpointを返す
        this.getPoint = (creativeFormat, itemType) => {
            const pricingTable = this.pricingTables
                ? this.pricingTables.find(_pricingTable => _pricingTable.creativeTypeId == creativeFormat.creativeType.id)
                : null;
            return pricingTable.getPoint(creativeFormat, itemType);
        };
        this.id = id;
        this.name = name;
        this.displayToOptimizer = displayToOptimizer;
        this.helpUrlForDirector = helpUrlForDirector;
        this.helpUrlForOptimizer = helpUrlForOptimizer;
        this.pricingTables = pricingTables;
    }
    static fromJSON(json) {
        const { id, name, displayToOptimizer, helpUrlForDirector, helpUrlForOptimizer, pricingTables } = Object.assign({}, json);
        if (typeof id !== 'string')
            throw new Error('.id must be a string');
        if (typeof name !== 'string')
            throw new Error('.name must be a string');
        return new PricingMerchandiseOption({
            id,
            name,
            displayToOptimizer,
            helpUrlForDirector,
            helpUrlForOptimizer,
            pricingTables: pricingTables
                ? pricingTables.map((_pricingTable) => PricingTable_1.default.fromJSON(_pricingTable))
                : undefined,
        });
    }
}
exports.default = PricingMerchandiseOption;
